import React, { useEffect, useState } from "react";
import '../../../CSS/Areas.css'
import {BsPlus} from "react-icons/bs";
import {getPermission} from '../../../Conexiones/Conexion'
import { useNavigate } from "react-router";
import { FaArrowLeftLong } from "react-icons/fa6";
import { deleteApi, getApi, postApi, putApi } from "../../../Conexiones/Models";
import { errorMessage, errorToast, successToast, warningModal, warningToast } from "../../../Utils/AlertMessage";
import { Button, CloseButton, Modal } from "react-bootstrap";
import Loading from '../../../Utils/Loading';

function Tramites(){
    const navigate = useNavigate();
    const [tramites, setTramites] = useState([]);
    const [tablaTramites, setTablaTramites] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const uri = 'tramites/';
    const [isLoading,setIsLoading]=useState(false);

    useEffect( ()=>{
        const getTramites = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,2);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setTramites(res.data)
                        setTablaTramites(res.data)
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getTramites()
    },[idUsuario,navigate])

    const getTramites = async () =>{
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setTramites(res.data)
                setTablaTramites(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaTramites.filter((elemento)=> {
            if(elemento.nombreTramite.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento;
            }
            return resBusqueda
        })
        setTramites(resBusqueda)
    }

    const regresar = () => {
        navigate('/inicio/Catalogos')
    }

    const modalDelete = (id) => {
        warningModal('¿QUIERES ELIMINAR ESTE TRAMITE?')
        .then(async (result) => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="¡Registro eliminado correctamente!"){
                        getTramites();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }

    const [idTramite,setIdTramite] = useState ('')
    const [nombre, setNombre] = useState('');
    const [isSaving, setSaving] = useState(false);

    //AGREGAR
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const store = async (e) =>{
        setSaving(true)
        e.preventDefault()
        if(nombre.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = uri;
            const data = {nombreTramite:nombre};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleClose();
                    getTramites();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false)
    }

    //Editar
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = (id,nombre) =>{
        setNombre(nombre);
        setIdTramite(id);
        setShowEdit(true);
    }
    const update = async (e) =>{
        setSaving(true)
        e.preventDefault()
        if(nombre.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = uri + idTramite;
            const data = {nombreTramite:nombre};
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro actualizado correctamente!"){
                    handleCloseEdit();
                    getTramites();
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false)
    }  
     
    return(
        <div className="areas">
            {
                isLoading ?
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">GESTIÓN DE TRAMITES</label>
                    </div>            
                    <div className='divbotonA' >                                                                                             
                        <div className='botonA' style={{display:'flex', justifyContent:'space-between'}} >
                            <button title='Agregar Area' style={{justifyContent:'center'}} className="btn btn-light btncolor" onClick={handleShow} type="button">
                                <label className="agregar">TRAMITE</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>                    
                        </div>
                    </div>
                    {
                        tramites.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaA" >
                                <div className="table tabla">
                                    <table className="table table-hover table-bordered text-uppercase">
                                        <thead className="encabezado">
                                            <tr >                                
                                                <th>TRAMITE</th>
                                                <th style={{width:'50%'}}>ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {tramites.map(t =>{
                                                return(                                    
                                                    <tr key={t.idTramite}>                                       
                                                        <td valign="middle">{t.nombreTramite}</td>
                                                        <td>
                                                            <div>
                                                                <div className="btn iconoH" onClick={() => handleShowEdit(t.idTramite,t.nombreTramite)} style={{margin:'5px'}}>
                                                                    <span className="bi bi-pen" title="EDITAR"></span>
                                                                </div>
                                                                <div className="btn iconoH" style={{margin:'5px'}} onClick={() => modalDelete(t.idTramite)}>
                                                                    <span className="bi bi-trash" title="ELIMINAR"></span>
                                                                </div>                                     
                                                            </div>
                                                        </td>                                                                                                
                                                    </tr>                                                                        
                                                )
                                            })}                        
                                        </tbody>
                                    </table>
                                </div>      
                            </div>
                        )
                    }

                    {/*AGREGAR TRAMITE*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-tramite">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR TRAMITE</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={store}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setNombre(e.target.value) }/>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleClose}>CANCELAR</Button>                                               
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>

                    {/*EDITAR TRAMITE*/}
                    <Modal  show={showEdit} onHide={handleCloseEdit} id="modal-editar-tramite">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR TRAMITE</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label" style={{color:'black'}}>NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" value={nombre} 
                                    onChange={(e) => setNombre(e.target.value) }  required/>
                                </div> 
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</Button>                                               
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    )
}

export default Tramites;